// import axios from 'axios'
import axios from './axios'
import { URLS, VIDEO_PROTOCOL } from '../config'
import { isHttps, isOnvif } from '../utils'

/**
 * 此处mode使用string
 */
const deployBaseRoute = window.deployBaseRoute || '/'
axios.interceptors.request.use(
  (config) => {
    config.baseURL = deployBaseRoute
    return config
  },
)  

// 优先级最高 兼容特殊URL对接安元平台
export async function supportSpecialFlagUrl(proxyHost, iotVideoObj) {
  let mode, url, urls
  return new Promise(async (resolve, reject) => {
    let gbRes = await axios.get(proxyHost + URLS.startGBPreviewUrl, { params: { url: iotVideoObj.stream } }).catch((e) => {
      reject('error')
    })
    if (gbRes.data.status == 200) {
      mode = '11'
      url = isHttps() ? res.data.result.https_flv : res.data.result.flv
      urls = [{url: res.data.result.flv, type: 'FLV'}, {url: res.data.result.https_flv, type: 'FLV'}, {url: res.data.result.hls, type: 'HLS'}, {url: res.data.result.https_hls, type: 'HLS'}, {url: res.data.result.rtsp, type: 'RTSP'}]
      resolve({ mode, url, urls })
    } else {
      reject('startGBPreviewUrl: 取流失败')
    }
  })
}

// 支持转码流
export async function supportRepackingUrl(proxyHost, stream, iotVideoObj) {
  let mode, url;
  return new Promise(async (resolve, reject) => {
    const params = {
      stream: stream
    }
    let rtspRes = await axios.post(proxyHost + URLS.rtspRepackagingUrl, params).catch((e) => {
      reject('error')
    })
    if (rtspRes.data.status == 200) {
      if (iotVideoObj.proxyStreamType == 'flv') {
        url = isHttps() ? rtspRes.data.result.wss_flv : rtspRes.data.result.ws_flv
      } else if (iotVideoObj.proxyStreamType == 'hls') {
        url = isHttps() ? rtspRes.data.result.wss_hls : rtspRes.data.result.ws_hls
      }
      resolve({mode: null, url})
    } else {
      reject('rtspRepackagingUrl: 取流失败')
    }
  })
}

// 支持海康流转码
export async function supportHikvisonRepackingUrl(proxyHost, iotVideoObj, hkConfig) {
  let mode, url;
  return new Promise(async (resolve, reject) => {
    const protocol = hkConfig && hkConfig.protocol ? hkConfig.protocol : iotVideoObj.proxyStreamType;
    const params = {
      videoCode: iotVideoObj.code,
      streamType: 0,
      protocol: protocol,
      expand: 'streamform=rtp&transcode=1'
    }
    let hkRes = await axios.post(proxyHost + URLS.getHKH5VideoUrl, params).catch((e) => {
      reject('error')
    })
    if (hkRes.data.status == 200 && hkRes.data.result) {
      mode = protocol.toLowerCase() === "hls" || protocol.toLowerCase() === "flv" ? '0' : protocol.toLowerCase() === "ws" ? '13' : '2';
      url = hkRes.data.result
      resolve({mode: mode, url})
    } else {
      reject('getHKH5VideoUrl: 取流失败')
    }
  })
}

// 支持NY流播放
export async function supportNYUrl(proxyHost, iotVideoObj) {
  let mode, url;
  return new Promise(async (resolve, reject) => {
    let nyRes = await axios.get(proxyHost + URLS.NYPreview, { params: { code: iotVideoObj.code } }).catch((e) => {
      reject('error')
    })
    if (nyRes.data.status == 200 && nyRes.data.result.token) {
      url = nyRes.data.result.url
      mode = '0'
      // this.playNYToken = nyRes.data.result.token
      resolve({mode: mode, url, token: nyRes.data.result.token })
      // this._startNyKeepAlive(nyRes.data.result.token)
    } else {
      reject('NYPreview: 取流失败')
    }
  })
}

// 支持iVMS海康平台播放
export async function supportIVMSUrl(proxyHost, iotVideoObj) {
  let mode, url;
  return new Promise(async (resolve, reject) => {
    const data = {
      code: iotVideoObj.code,
      streamType: 0,
      protocol: 'rtsp_s',
      transmode: 0,
      expand: ''
    }

    let ivmshkRes = await axios.post(URLS.ISVMSHKPreview, data).catch((e) => {
      reject('error')
    })
    if (ivmshkRes.data.status == 200) {
      url = ivmshkRes.data.result
      mode = '2'
      resolve({mode: mode, url })
    } else {
      reject('ISVMSHKPreview: 取流失败')
    }
  })
}

// 支持ay平台 gb onvif jt1078
export async function supportAYUrl(proxyHost, iotVideoObj) {
  let mode, url;
  return new Promise(async (resolve, reject) => {
    const id = iotVideoObj.id || iotVideoObj.code

    let res = await axios.get(proxyHost + URLS.ayPreviewUrl, { params: { id: id, code: iotVideoObj.code, channelId: iotVideoObj.channelId } }).catch((err) => {
      reject('error')
    })
    if (res && res.status === 200) {
      // 0 Native 1 IFrame 2 VLC 3 HK
      if (isOnvif(iotVideoObj.code)) {
        if (!(res.data.result instanceof Array) || !res.data.result[0].rtsp) {
          reject('获取Onvif视频流失败！请检查！')
        }
        // 支持onvif开启转码
        if (iotVideoObj.isProxyStream) {
          let repackRes = await supportRepackingUrl(proxyHost, res.data.result[0].rtsp, iotVideoObj).catch(e => {
            return 'error'
          });
          if (repackRes != 'error') {
            resolve(repackRes)
          } else {
            reject('Onvif流转码失败！请检查！')
          }
        } else {
          resolve({url: res.data.result[0].rtsp})
        }
      } else if (res.data.result) {
        // H5 转流
        //   if (iotVideoObj.isProxyStream) {
        //       const params =
        //         typeof res.data.result === 'object'
        //           ? {
        //               stream: res.data.result.rtsp
        //             }
        //           : { stream: res.data.result }
        //       let rtspRes = await axios.post(proxyHost + URLS.rtspRepackagingUrl, params).catch((e) => {
        //         reject('error')
        //       })
        //       if (rtspRes.data.status == 200) {
        //         if (iotVideoObj.proxyStreamType == 'flv') {
        //           url = isHttps() ? rtspRes.data.result.wss_flv : rtspRes.data.result.ws_flv
        //         } else if (iotVideoObj.proxyStreamType == 'hls') {
        //           url = isHttps() ? rtspRes.data.result.wss_hls : rtspRes.data.result.ws_hls
        //         }
        //       } 
        // } else {
          // ws_flv
          const wsUrl = Object.keys(res.data.result).filter((item) => {
            return item.includes('ws')
          })
          if (wsUrl.length) {
            url = isHttps() ? res.data.result.wss_flv : res.data.result.ws_flv
          } else {
            url = isHttps() ? res.data.result.https_flv : res.data.result.flv;    
          }
        // }
         
        resolve({url})
      } else {
        reject('获取GB视频流地址失败，请检查接口返回！')
      }
    }
  })
}

// 支持其他平台新取流接口
export async function supportNewPreviewUrl(proxyHost, iotVideoObj, mediaType = 'RTSP', proxyType, transType) {
  let mode, url
  const params = proxyType ? { code: iotVideoObj.code, mediaType, proxyType } : { code: iotVideoObj.code, mediaType };
  if(iotVideoObj.source==='hikvision') Object.assign(params,{transType});
  return new Promise(async (resolve, reject) => {
    let res = await axios.get(proxyHost + URLS.previewUrl, { params, }).catch((err) => {
      reject('error')
    })
    if (res && res.status === 200) {
      // 0 Native 1 IFrame 2 VLC 3 HK
      url = res.data.result
      resolve({ url })
    }
  })
}